export default __webpack_public_path__ + "static/media/7_1.f2961995.jpg";